<div class="container mb-4">
  <div class="d-inline-block me-3 pointer" [ngClass]="{'inactive': currentLanguage != 'fr'}" (click)="changeLanguage('fr')">
    <img width="24" src="/assets/img/fr.png" /> Français
  </div>
  <div class="d-inline-block pointer" [ngClass]="{'inactive': currentLanguage != 'en'}" (click)="changeLanguage('en')">
    <img width="24" src="/assets/img/en.png" /> Anglais
  </div>
</div>
<div class="container-fluid h-100" id="containerEditor">
  <div  id="jsoneditor"></div>

</div>
